function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-contaners{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:.8px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic-cs",
  transform: "translate(.4 .4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15749",
  "data-name": "Group 15749",
  transform: "translate(0 6.168)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_520",
  "data-name": "Line 520",
  className: "cls-contaners",
  d: "M0 0h5.596"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_521",
  "data-name": "Line 521",
  className: "cls-contaners",
  transform: "translate(1.628 1.74)",
  d: "M0 0h5.596"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_522",
  "data-name": "Line 522",
  className: "cls-contaners",
  transform: "translate(0 3.488)",
  d: "M0 0h5.596"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_15750",
  "data-name": "Group 15750",
  transform: "translate(2.784)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_523",
  "data-name": "Line 523",
  className: "cls-contaners",
  transform: "translate(6.608 5.045)",
  d: "M0 0v8.179"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_524",
  "data-name": "Line 524",
  className: "cls-contaners",
  transform: "translate(0 2.639)",
  d: "M0 3.414V0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9519",
  "data-name": "Path 9519",
  className: "cls-contaners",
  d: "M262.825 1171.326v8.8l-6.608 2.124-6.608-2.124v-1.7",
  transform: "translate(-249.608 -1168.687)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_525",
  "data-name": "Line 525",
  className: "cls-contaners",
  transform: "translate(10.981 2.639)",
  d: "M2.235 0 0 .814"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9520",
  "data-name": "Path 9520",
  className: "cls-contaners",
  d: "m258.534 1172.892-2.311.841-6.608-2.407",
  transform: "translate(-249.615 -1168.687)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9521",
  "data-name": "Path 9521",
  className: "cls-contaners",
  d: "m262.825 1128.173-6.608-2.639-6.608 2.639",
  transform: "translate(-249.608 -1125.534)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_15751",
  "data-name": "Group 15751",
  transform: "translate(5.157 .841)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_526",
  "data-name": "Line 526",
  className: "cls-contaners",
  transform: "translate(2.131)",
  d: "M6.479 2.613 0 0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_527",
  "data-name": "Line 527",
  className: "cls-contaners",
  transform: "translate(0 .851)",
  d: "M6.547 2.512 0 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_9522",
  "data-name": "Path 9522",
  className: "cls-contaners",
  d: "M406.455 1185.453v2.425l-.856-.332-1.207 1.033v-2.379",
  transform: "translate(-392.689 -1182)"
}));

function SvgContainers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.92,
    height: 14.367,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainers);
export default __webpack_public_path__ + "static/media/containers.69cb5e81.svg";
export { ForwardRef as ReactComponent };